import { styled } from '@/styled-system/jsx';
import Text from 'app/shared/core/Text';

export const AreaPage = styled('div', {
  base: {
    backgroundColor: 'hpxWhite',
    marginTop: 'token(sizes.mobileHeaderHeight)',

    md: {
      width: 'sidebarWidthMdBiggerListingCards',
    },

    xxl: {
      width: 'sidebarWidthXlBiggerListingCards',
    },
  },
});

export const AreaPageDivider = styled('div', {
  base: {
    clear: 'both',
    width: '100%',
    marginTop: '20px',
    marginBottom: '20px',
    borderBottomWidth: '4px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'hpxGrey100',
  },
});

export const AreaPageLimitingText = styled('section', {
  base: {
    width: '85%',
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: '3x',
    paddingBottom: '3x',
  },
});

export const DarkPageLimitNotice = styled(Text, {
  base: {
    color: 'hpxGrey600',
  },
});
